import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

import { InputClearBtnModule } from '../input-clear-btn/input-clear-btn.module';
import { InputErrorModule } from '../input-error/input-error.module';
import { IbSpinnerModule } from '../spinner/spinner.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { MatFormFieldWrapComponent } from './mat-form-field-wrap.component';

@NgModule({
  declarations: [MatFormFieldWrapComponent],
  imports: [
    CommonModule,
    IbSpinnerModule,
    MatButtonModule,
    InputClearBtnModule,
    MatFormFieldModule,
    InputErrorModule,
    TooltipModule,
  ],
  exports: [MatFormFieldWrapComponent],
})
export class MatFormFieldWrapModule {}
